import { GeneralModel } from "./general.model";

export class CalculateBy extends GeneralModel {
}